export default "__VITE_ASSET__WLwUH62yRROKVGOdYSMHbg__";